import { useTranslation } from 'react-i18next'
import { FaTrashAlt } from 'react-icons/fa'

import { Button, Grid, Tooltip } from '@mui/material'
import { cloneDeep } from 'lodash'

import { useField, useFormikContext } from 'formik'

import InputField from 'components/atoms/fields/InputField'
import DatePickerField from 'components/atoms/fields/DatePickerField'

import { IRtiRiskCriteriaOneDocument } from 'types'


const RtiRiskCriteriaOneDocumentRow = ({ fieldProps, disabled, index }) => {
  const { t } = useTranslation()

  const [field] = useField<IRtiRiskCriteriaOneDocument[]>(fieldProps.name)
  const { setFieldValue } = useFormikContext() // Manually set field value in Formik state


  const handleRemoveEntity = () => {
    const entities = cloneDeep(field.value)
    entities.splice(index, 1)
    setFieldValue(fieldProps.name, entities)
  }

  return (
    <Grid
      container
      spacing={2}
      key={index}
      sx={{
        marginBottom: '10px',
        marginTop: '10px',
      }}
    >
      <Grid item xs={6} lg={4}>
        <InputField
          valueSelector='measure'
          fieldProps={{
            label: t('rti.measure'),
            name: `${fieldProps.name}[${index}]`,
          }}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={6} lg={2}>
        <InputField
          valueSelector='student_score'
          fieldProps={{
            label: t('rti.student-score'),
            name: `${fieldProps.name}[${index}]`,
          }}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={6} lg={2}>
        <InputField
          valueSelector='standard_score'
          fieldProps={{
            label: t('rti.standard-score'),
            name: `${fieldProps.name}[${index}]`,
          }}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={6} lg={2}>
        <DatePickerField 
          valueSelector='date_given'
          fieldProps={{
            label: t('common.date-given'),
            name: `${fieldProps.name}[${index}]`,
          }}
         disabled={disabled} />
      </Grid>

      <Grid item xs={1} sx={{ display: 'flex' }}>

            <Tooltip title={`${t('common.delete')}`} arrow placement='top'>
              <Button
                onClick={() => handleRemoveEntity()}
                aria-label='delete'
                size='small'
                disabled={disabled}
                color='error'
                variant='outlined'
                sx={{
                  margin: '0',
                  boxShadow: 'none',
                  padding: '0.5rem 0.1rem',
                  minWidth: '2.5rem !important',
                  maxWidth: '2.5rem !important',
                }}
              >
                <FaTrashAlt style={{ fontSize: '1.2rem' }} />
              </Button>
            </Tooltip>

      </Grid>

    </Grid>
  )
}
export default RtiRiskCriteriaOneDocumentRow
